import {
	AccessibilityHelp,
	Alignment,
	Autoformat,
	AutoLink,
	Autosave,
	BlockQuote,
	Bold,
	Code,
	Essentials,
	FindAndReplace,
	GeneralHtmlSupport,
	Heading,
	Highlight,
	HtmlComment,
	Indent,
	IndentBlock,
	Italic,
	Link,
	Paragraph,
	RemoveFormat,
	SelectAll,
	ShowBlocks,
	Strikethrough,
	Subscript,
	Superscript,
	Table,
	TableCaption,
	TableCellProperties,
	TableColumnResize,
	TableProperties,
	TableToolbar,
	TextTransformation,
	Underline,
	Undo,
    Image,
    Clipboard,
    Base64UploadAdapter,
    ImageUpload,
    Mention,
    Command,
    Plugin

} from 'ckeditor5'

export const editorConfig = (provider)=>{

    const plugins = [
		AccessibilityHelp,
		Alignment,
		Autoformat,
		AutoLink,
		Autosave,
		BlockQuote,
		Bold,
		Code,
		Essentials,
		FindAndReplace,
		GeneralHtmlSupport,
		Heading,
		Highlight,
		HtmlComment,
		Indent,
		IndentBlock,
		Italic,
		Link,
		Paragraph,
		RemoveFormat,
		SelectAll,
		ShowBlocks,
		Strikethrough,
		Subscript,
		Superscript,
		Table,
		TableCaption,
		TableCellProperties,
		TableColumnResize,
		TableProperties,
		TableToolbar,
		TextTransformation,
		Underline,
		Undo,
        Image,
        Clipboard,
        Mention,
        MentionCustomization,
        EmojiPlugin
	];

    if(provider){
        plugins.push(Base64UploadAdapter)
        plugins.push(ImageUpload)
    }

    return {
	toolbar: {
		items: [
			'undo',
			'redo',
			'|',
			'showBlocks',
			'|',
			'heading',
			'|',
			'bold',
			'italic',
			'underline',
			'strikethrough',
			'code',
			'removeFormat',
			'|',
            'insertImage',
            '|',
			'link',
			'blockQuote',
			'|',
			'alignment'
		],
		shouldNotGroupWhenFull: true
	},
	plugins: plugins,
    image: provider ?  {
        toolbar: [
            'imageStyle:block',
            'imageStyle:side',
            '|',
            'toggleImageCaption',
            'imageTextAlternative',
            '|',
            'linkImage'
        ],
        insert: {
            type: 'inline'
        }
    } : null,
	heading: {
		options: [
			{
				model: 'paragraph',
				title: 'Paragraph',
				class: 'ck-heading_paragraph'
			},
			{
				model: 'heading1',
				view: 'h1',
				title: 'Heading 1',
				class: 'ck-heading_heading1'
			},
			{
				model: 'heading2',
				view: 'h2',
				title: 'Heading 2',
				class: 'ck-heading_heading2'
			},
			{
				model: 'heading3',
				view: 'h3',
				title: 'Heading 3',
				class: 'ck-heading_heading3'
			},
			{
				model: 'heading4',
				view: 'h4',
				title: 'Heading 4',
				class: 'ck-heading_heading4'
			},
			{
				model: 'heading5',
				view: 'h5',
				title: 'Heading 5',
				class: 'ck-heading_heading5'
			},
			{
				model: 'heading6',
				view: 'h6',
				title: 'Heading 6',
				class: 'ck-heading_heading6'
			}
		]
	},
	htmlSupport: {
		allow: [
			{
				name: /^.*$/,
				styles: true,
				attributes: true,
				classes: true
			}
		]
	},
	initialData: '',
	link: {
		addTargetToExternalLinks: true,
		defaultProtocol: 'https://',
		decorators: {
			toggleDownloadable: {
				mode: 'manual',
				label: 'Downloadable',
				attributes: {
					download: 'file'
				}
			}
		}
	},
	placeholder: 'Type a message...',
	table: {
		contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells', 'tableProperties', 'tableCellProperties']
	}
};


function MentionCustomization( editor ) {
    // The upcast converter will convert <a class="mention" href="" data-user-id="">
    // elements to the model 'mention' attribute.
    editor.conversion.for( 'upcast' ).elementToAttribute( {
        view: {
            name: 'a',
            key: 'data-mention',
            classes: 'mention',
            attributes: {
                href: true,
                'data-user-id': true
            }
        },
        model: {
            key: 'mention',
            value: viewItem => {
                // The mention feature expects that the mention attribute value
                // in the model is a plain object with a set of additional attributes.
                // In order to create a proper object, use the toMentionAttribute helper method:
                const mentionAttribute = editor.plugins.get( 'Mention' ).toMentionAttribute( viewItem, {
                    // Add any other properties that you need.
                    link: viewItem.getAttribute( 'href' ),
                    userId: viewItem.getAttribute( 'data-user-id' )
                } );

                return mentionAttribute;
            }
        },
        converterPriority: 'high'
    } );

    // Downcast the model 'mention' text attribute to a view <a> element.
    editor.conversion.for( 'downcast' ).attributeToElement( {
        model: 'mention',
        view: ( modelAttributeValue, { writer } ) => {
            // Do not convert empty attributes (lack of value means no mention).
            if ( !modelAttributeValue ) {
                return;
            }
            console.log("Mention value",modelAttributeValue)

            return writer.createAttributeElement( 'at', {
                class: 'mention',
                'data-mention': modelAttributeValue.name,
                'id': modelAttributeValue.userId,
                html: modelAttributeValue.name
            }, {
                // Make mention attribute to be wrapped by other attribute elements.
                priority: 20,
                // Prevent merging mentions together.
                id: modelAttributeValue.userId
            } );
        },
        converterPriority: 'high'
    } );
}

}


class InsertEmojiCommand extends Command {
    execute({ emoji }) {
        const editor = this.editor;
        editor.model.change(writer => {
            // Create a new emoji element
            const emojiElement = writer.createElement('emoji', { emoji });
            // Insert emoji at the current selection or the closest valid position
            const insertPosition = editor.model.document.selection.getFirstPosition();
            writer.insert(emojiElement, insertPosition);
            writer.setSelection(writer.createPositionAfter(emojiElement));
        });
    }

    refresh() {
        const model = this.editor.model;
        const selection = model.document.selection;
        this.isEnabled = model.schema.checkChild(selection.focus.parent, 'emoji');
    }
}

class EmojiPlugin extends Plugin {
    init() {
        const editor = this.editor;

        // Register the emoji schema
        editor.model.schema.register('emoji', {
            allowWhere: '$text',
            isInline: true,
            isObject: true,
            allowAttributes: ['emoji']
        });

        // Define how the emoji should render in the view
        editor.conversion.for('downcast').elementToElement({
            model: 'emoji',
            view: (modelItem, { writer }) => {
                const emoji = modelItem.getAttribute('emoji');
                const span = writer.createContainerElement('span', {
                    class: 'emoji-icon',
                    contenteditable: 'false'
                });
                writer.insert(writer.createPositionAt(span, 0), writer.createText(emoji));
                return span;
            }
        });

        // Define the upcast converter
        editor.conversion.for('upcast').elementToElement({
            view: {
                name: 'span',
                classes: 'emoji-icon'
            },
            model: (viewElement, { writer }) => {
                const emoji = viewElement.getChild(0).data;
                return writer.createElement('emoji', { emoji });
            }
        });

        // Register the insertEmoji command
        editor.commands.add('insertEmoji', new InsertEmojiCommand(editor));
    }
}
